import { filesBrowseApi } from './browse';
import { filesChildrenApi } from './children';
import { filesUploadApi } from './upload';
import { filesJobsApi } from './jobs';
import { filesAuditApi } from './audit';
import { filesFlightMetaApi } from './flightMeta';
import { filesLookupsApi } from './lookups';

export const filesApi = {
  ...filesBrowseApi,
  ...filesChildrenApi,
  ...filesUploadApi,
  ...filesJobsApi,
  ...filesAuditApi,
  ...filesFlightMetaApi,
  ...filesLookupsApi,
};
